import {call, put, select, takeLatest} from 'redux-saga/effects'
import {push} from 'connected-react-router'
import AuthActions, {AuthSelectors} from '../LoginPage/reducer'
import ErrorsActions from '../../Redux/ErrorsRedux'
import utils from '../../Utils/utils'

import * as services from './services'
import Creators, { OnboardingTypes as constants } from './reducer';

export function* getCountries({}) {
  try {
    const response = yield call(services.getCountries)
    if (response?.ok) {
      yield put(Creators.countriesSuccess(response.data))
    } else {
      if (response?.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(Creators.onBoardingFetchingReset())
    }
  } catch (e) {
    yield put(Creators.onBoardingFetchingReset())
    yield put(ErrorsActions.errorSave(`Server response error: ${e}`))
  }
}

export function* checkDiscountCode({code}) {
  try {
    const response = yield call(services.checkDiscountCode, code)
    if (response?.ok) {
      yield put(Creators.checkDiscountCodeSuccess(response.data))
    } else {
      if (response?.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(Creators.checkDiscountCodeFailure(true))
      yield put(Creators.onBoardingFetchingReset())
    }
  } catch (e) {
    yield put(Creators.onBoardingFetchingReset())
    yield put(ErrorsActions.errorSave(`Server response error: ${e}`))
  }
}

export function* saveSubscription({data}) {
  try {
    const response = yield call(services.saveSubscription, data)
    const userInfo = yield select(AuthSelectors.getUserInfo)
    if (response?.ok && response?.data) {
      if (response?.data?.paid) {
        yield put(Creators.saveSubscriptionSuccess(response.data?.user.subscription))
        if (userInfo.onboarding_finished) {
          yield put(AuthActions.updateProfile(response.data.user))
        } else {
          yield put(Creators.changeSubscriptionReset())
          yield put(AuthActions.updateProfile({...userInfo, ...response.data.user}))
          yield put(push('/onboarding/checkout/success'))
        }
      } else {
        yield put(Creators.saveSubscriptionSecure(response.data))
        if (response.data.link) utils.goLink(response.data.link)
      }
    } else {
      if (response?.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 402) {
          yield put(Creators.saveSubscriptionSecure(response.data))
          if (response.data.link) utils.goLink(response.data.link)
        } else if (response.status === 500) {
          yield put(Creators.saveSubscriptionFailure(true))
          yield put(ErrorsActions.errorSave(response.data))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(Creators.onBoardingFetchingReset())
    }
  } catch (e) {
    yield put(Creators.onBoardingFetchingReset())
    yield put(ErrorsActions.errorSave(`Server response error: ${e}`))
  }
}

export function* updateSubscription({data}) {
  try {
    const userInfo = yield select(AuthSelectors.getUserInfo)
    const response = userInfo?.subscription ? yield call(services.updateSubscription, data) : yield call(services.saveSubscription, data)
    if (response?.ok && response?.data) {
      if (response?.data?.paid) {
        yield put(Creators.updateSubscriptionSuccess(response.data.user.subscription))
        yield put(AuthActions.updateProfile({...userInfo, ...response.data.user}))
      } else {
        yield put(Creators.updateSubscriptionSecure(response.data))
        if (response.data.link) utils.goLink(response.data.link)
      }
    } else {
      if (response?.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 402) {
          yield put(Creators.updateSubscriptionSecure(response.data))
          if (response.data.link) utils.goLink(response.data.link)
        } else if (response.status === 500) {
          yield put(Creators.updateSubscriptionFailure(true))
          yield put(ErrorsActions.errorSave(response?.data))
        } else {
          yield put(ErrorsActions.errorSave(response?.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(Creators.onBoardingFetchingReset())
    }
  } catch (e) {
    yield put(Creators.onBoardingFetchingReset())
    yield put(ErrorsActions.errorSave(`Server response error: ${e}`))
  }
}

export function* deleteSubscription({}) {
  try {
    const response = yield call(services.deleteSubscription)
    if (response?.ok && response?.data?.user?.subscription?.id) {
      yield put(Creators.deleteSubscriptionSuccess({
        ...response.data.user.subscription,
        old_schedule: response?.data?.old_schedule,
      }))
      yield put(
        AuthActions.updateProfile({subscription: {...response.data.user.subscription}}),
      )
    } else {
      if (response?.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(Creators.deleteSubscriptionFailure(true))
          yield put(ErrorsActions.errorSave(response.data))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(Creators.onBoardingFetchingReset())
    }
  } catch (e) {
    yield put(Creators.onBoardingFetchingReset())
    yield put(ErrorsActions.errorSave(`Server response error: ${e}`))
  }
}

export function* undoDeleteSubscription({data}) {
  try {
    const response = yield call(services.undoDeleteSubscription, data)
    if (response?.ok && response?.data?.user?.subscription?.id) {
      yield put(Creators.undoDeleteSubscriptionSuccess(response?.data?.user?.subscription))
      yield put(AuthActions.updateProfile({subscription: {...response?.data?.user?.subscription}}),)
    } else {
      if (response?.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(Creators.undoDeleteSubscriptionFailure(true))
          yield put(ErrorsActions.errorSave(response.data))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(Creators.onBoardingFetchingReset())
    }
  } catch (e) {
    yield put(Creators.onBoardingFetchingReset())
    yield put(ErrorsActions.errorSave(`Server response error: ${e}`))
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.COUNTRIES_REQUEST, getCountries)
  yield takeLatest(constants.CHECK_DISCOUNT_CODE_REQUEST, checkDiscountCode)
  yield takeLatest(constants.SAVE_SUBSCRIPTION_REQUEST, saveSubscription)
  yield takeLatest(constants.UPDATE_SUBSCRIPTION_REQUEST, updateSubscription)
  yield takeLatest(constants.DELETE_SUBSCRIPTION_REQUEST, deleteSubscription)
  yield takeLatest(constants.UNDO_DELETE_SUBSCRIPTION_REQUEST, undoDeleteSubscription)
}
